import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Wizard } from "./Wizard";
import steps from "./Steps";

const App = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LfgZa4cAAAAAONsrLEzdHlGEztD-ONrHIs36G6W">
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='text-center mt-3 mb-3'>Privacy Policy Generator</h1>
            <Wizard steps={steps} />
          </div>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
